module.exports = __webpack_public_path__ + "img/gglr-icon.50f9b175.png";